import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { RequestForFundsSelectors } from './request-for-funds.selector';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import {
	FinalReport,
	RequestForFunds,
} from '@models/mortgages/closer-sync-request-for-funds';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { CloserSyncInstructionsAPIService } from 'src/app/shared/api-repos/mortgages/closer-sync-instructions.api.service';
import { SnackbarService } from '@services/ui/snackbar.service';
import { MatterBusinessUser } from '@models/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import LogRocket from 'logrocket';

export interface CloserSyncRFFComponentData {
	type: 'REQUEST_FOR_FUNDS' | 'FINAL_REPORT';
}

@Component({
	selector: 'app-closer-sync-rff',
	templateUrl: './closer-sync-rff.component.html',
	styles: [
		`
			:host {
				@apply flex min-h-0 h-full overflow-hidden;
			}
		`,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncRFFComponent {
	@SelectSnapshot(RequestForFundsSelectors.RequestForFunds)
	requestForFunds: RequestForFunds;
	@SelectSnapshot(RequestForFundsSelectors.FinalReport)
	finalReportRequest: FinalReport;

	@SelectSnapshot(SelectedMatter.assignedLawyer) lawyer: MatterBusinessUser;

	private submitSubject = new BehaviorSubject<boolean>(false);
	public submitting$: Observable<boolean> = this.submitSubject.asObservable();

	public requestType: 'REQUEST_FOR_FUNDS' | 'FINAL_REPORT' =
		'REQUEST_FOR_FUNDS';
	public title: string = 'Request for Funds Details';

	constructor(
		private dialogRef: MatDialogRef<CloserSyncRFFComponent>,
		private instructionsAPIService: CloserSyncInstructionsAPIService,
		private snackbarService: SnackbarService,
		@Inject(MAT_DIALOG_DATA) public data: CloserSyncRFFComponentData,
	) {
		this.requestType = data.type;
		if (this.requestType === 'FINAL_REPORT') {
			this.title = 'Final Report Details';
		}
		console.log(this.requestType, this.requestForFunds);
	}

	cancel() {
		this.dialogRef.close();
	}

	async submit() {
		const msg =
			this.requestType === 'REQUEST_FOR_FUNDS'
				? 'Request for Funds'
				: 'Final Report';
		this.submitSubject.next(true);

		try {
			if (this.requestType === 'REQUEST_FOR_FUNDS') {
				LogRocket.log(`Submitting Request For Funds`, this.requestForFunds);
				console.log(`Submitting Request For Funds`, this.requestForFunds);
				await this.instructionsAPIService
					.requestForFunds(
						this.requestForFunds?.instructionId,
						this.requestForFunds,
						this.lawyer.id,
					)
					.toPromise();
			} else {
				LogRocket.log(`Submitting Final Report`, this.finalReportRequest);
				console.log(`Submitting Final Report`, this.finalReportRequest);
				await this.instructionsAPIService
					.finalReport(
						this.requestForFunds?.instructionId,
						this.finalReportRequest,
						this.lawyer.id,
					)
					.toPromise();
			}
			this.dialogRef.close();
			this.snackbarService.openSnackBar({
				text: `${msg} submitted`,
				type: 'success',
			});
		} catch (err) {
			console.log('Error', err);
			LogRocket.log(`Error Submitting Request - ${this.requestType}`, err);
			this.snackbarService.openSnackBar({
				text: `Error submitting ${msg}`,
				type: 'error',
			});
		} finally {
			this.submitSubject.next(false);
		}
	}
}
